export class RingBuilderApi {

	constructor (endpoint) {
		this.endpoint = endpoint;
	}

	async send (getVar, data) {
		const response = await fetch(`${this.endpoint}get=${getVar}`, {
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		return response.json();
	}
};
